import { fun_PostAction } from "@/api/index";
import FormConfig from "@/views/page/record/contractProjectManager/formConfig";
import {Loading} from "_element-ui@2.15.14@element-ui";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 查询表单字段
      form: {
        prjName: null, // 项目名称
        regBasicinfoName: null, // 项目负责人(总监)
        regulators: null, // 招标监管部门
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "工程名称：",
          value: "prjName",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "项目负责人：",
          value: "regBasicinfoName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "行政监督部门：",
          value: "regulators",
          placeholder: "请选择",
          disabled: false,
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        },
      ],
      // 表头按钮组
      btnList: [
        {
          name: "解锁操作",
          type: "success",
          icon: "document-add"
        },
        {
          name: "变更操作",
          type: "success",
          icon: "document-add"
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "工程名称",
          prop: "prjName",
          width: "380",
          fixed: true,
        },
        {
          label: "中标单位",
          prop: "tenderUnits",
          width: "250",
          fixed: true,
        },
        {
          label: "项目负责人",
          prop: "regBasicinfoName",
          width: "180",
          fixed: true,
        },
        {
          label: "招标单位",
          prop: "tenderCorp",
          width: "250"
        },
        {
          label: "中标价（万元）",
          prop: "winningPrice",
          width: "150"
        },
        {
          label: "招投标监管部门",
          prop: "regulatorsName",
          width: "300"
        },
        {
          label: "公示时间",
          prop: "insertDate",
          width: "200"
        },
        {
          label: "招标方式",
          prop: "tenderTypeNum",
          width: "150"
        },
        {
          label: "招标类别",
          prop: "tenderClassNum",
          width: "150"
        },
        {
          label: "工程类别",
          prop: "tenderContent",
          width: "150"
        },
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 勾选的数组
      multipleSelection: [],
      /************************************项目负责人解锁/变更*********************************/
      // 默认关闭
      dialogVisible: false,
      // 查询表单绑定值
      chooseForm: {
        regBasicInfoName: null, // 项目负责人名称
        changeName: null, // 变更后项目负责人名称
        idNumber: null, // 项目负责人身份证
        changeIdNumber: null, // 项目负责人身份证
        tenderReference: null, // 招标编号
        prjName: null, // 项目名称
        flag: null, // 操作类型
      },
      // 表单错误
      errRules: {
        regBasicInfoName: null, // 项目负责人名称
        idNumber: null, // 项目负责人身份证
        changeName: null, // 变更后项目负责人名称
        changeIdNumber: null, // 项目负责人身份证
        prjName: null, // 项目名称
        tenderReference: null, // 招标编号
        flag: null, // 操作类型
      },
      // 表单配置
      formConfigList: null,
      // 全局加载
      fullLoading: null,
    };
  },
  // 注册组件
  components: {
  },

  // 模板编译完成
  mounted() {
    // 获取一览
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/projectManagerRecordOld/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      this.form[i] = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "解锁操作":
          // 解锁
          this.fun_OpenChoose("0");
          break;
        default:
          // 变更
          this.fun_OpenChoose("1");
      }
    },
    /**
     * 变更解锁操作
     */
    fun_OpenChoose(e){
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 设置负责人名称
          this.chooseForm.regBasicInfoName = this.multipleSelection[0].regBasicinfoName;
          // 设置负责人身份证
          this.chooseForm.idNumber = this.multipleSelection[0].idCard;
          // 设置项目名称
          this.chooseForm.prjName = this.multipleSelection[0].prjName;
          // 设置招标编号
          this.chooseForm.tenderReference = this.multipleSelection[0].tenderReference;
          // 设置操作标志
          this.chooseForm.flag = e;
          // 打开弹框
          this.dialogVisible = true;
          // 如果是解锁
          if(e == "0"){
            // 调用解锁
            this.fun_UnlockChoose();
          }
          // 如果是变更
          else{
            // 调用变更
            this.fun_ChangeChoose();
          }
        }
      } else {
        // 未勾选，则提示
        this.$alert("请至少选中一行数据！", "warning");
        return;
      }
    },
    /**
     * 解锁操作
     */
    fun_UnlockChoose(){
      // 设置表单
      this.formConfigList = [
        {
          label: "项目负责人名称：",
          value: "regBasicInfoName",
          type: "input",
          width: "100%",
          maxlength: 10,
          disabled: false,
          required: true,
          rule: {
            required: true,
            message: "该输入项不能为空",
            trigger: "blur"
          },
        },
        {
          label: "项目负责人身份证号：",
          value: "idNumber",
          type: "input",
          width: "100%",
          maxlength: 20,
          disabled: false,
          required: true,
          rule: {
            required: true,
            message: "该输入项不能为空",
            trigger: "blur"
          },
        },
      ]
    },
    /**
     * 变更操作
     */
    fun_ChangeChoose(){
      // 设置表单
      this.formConfigList = [
        {
          label: "项目负责人名称：",
          value: "regBasicInfoName",
          type: "input",
          width: "100%",
          maxlength: 10,
          disabled: false,
          required: true,
          rule: {
            required: true,
            message: "该输入项不能为空",
            trigger: "blur"
          },
        },
        {
          label: "项目负责人身份证号：",
          value: "idNumber",
          type: "input",
          width: "100%",
          maxlength: 20,
          disabled: false,
          required: true,
          rule: {
            required: true,
            message: "该输入项不能为空",
            trigger: "blur"
          },
        },
        {
          label: "更换项目负责人名称：",
          value: "changeName",
          type: "input",
          width: "100%",
          maxlength: 10,
          disabled: false,
          required: true,
          rule: {
            required: true,
            message: "该输入项不能为空",
            trigger: "blur"
          },
        },
        {
          label: "更换项目负责人身份证号：",
          value: "changeIdNumber",
          type: "input",
          width: "100%",
          maxlength: 20,
          disabled: false,
          required: true,
          rule: {
            required: true,
            message: "该输入项不能为空",
            trigger: "blur"
          },
        },
      ];
    },
    // 确定
    fun_Submit(){
      // 验证当前表单
      this.$refs.form.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 提交后台
          this.fun_SaveOrUpdate();
        } else {
          return false;
        }
      });
    },
    /**
     * 提交后台
     */
    fun_SaveOrUpdate(){
      // 打开遮罩
      this.fun_Loading();
      // 请求
      fun_PostAction("/projectManagerRecordOld/saveOrUpdate", {
        ...this.chooseForm, // form表单数据
      }).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 加载框取消
        this.fullLoading.close();
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 操作成功
          this.$message.success(msg);
          // 关闭弹框
          this.dialogVisible = false;
          // 获取一览表格数据
          this.fun_GetList();
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 返回
     */
    fun_Back(){
      // 关闭弹框
      this.dialogVisible = false;
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "正在进行效验，请耐心等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
  }
};
